import React, { useEffect } from "react";

import Visa from "../images/visa.png";
import Mastercard from "../images/mastercard.png";
import Discover from "../images/discover.png";
import Amex from "../images/amex.png";

const AcceptedCards = () => {
  useEffect(() => {});

  return (
    <div
      style={{
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 20,
        height: 60,
      }}
    >
      <img src={Visa} style={{ marginRight: 5, height: 40 }} alt="visa" />
      <img
        src={Mastercard}
        style={{ height: 40, marginRight: 5 }}
        alt="mastercard"
      />
      <img
        src={Discover}
        style={{ height: 40, marginRight: 5 }}
        alt="discover"
      />
      <img src={Amex} style={{ height: 40, marginRight: 5 }} alt="amex" />
    </div>
  );
};

export default AcceptedCards;
